import * as React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import Button from "@mui/material/Button";
import { Button as FooterButton } from "react-bootstrap";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import DialogContentText from "@mui/material/DialogContentText";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Card, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { updatePartner } from "../../API/endpoints/Partner";
import { requestForInformation } from "../../API/endpoints/Partner";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import ToastMessage from "../components/toasts/ToastMessage";

export default function SplitButton(props: {
  partnerData: any;
  onRequestForCall: (id: string) => void;
  reload?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [openRequestCallModal, setOpenRequestCallModal] = useState(false);
  const [inforReq, setInforReq] = useState<any>("");
  const [inforReqList, setInforReqList] = useState<any[]>([]);
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);
  const [calendlyPrefill, setCalendlyPrefill] = useState({
    email: "",
    name: "",
  });
  const [notification, setNotification] = useState({ type: "", msg: "" });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      docName: "",
      description: "",
    },
  });

  const handleCloseNotification = () => {
    setNotification({
      type: "",
      msg: "",
    });
  };

  useCalendlyEventListener({
    // onProfilePageViewed: () => console.log("onProfilePageViewed"),
    // onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
    // onEventTypeViewed: () => console.log("onEventTypeViewed"),
    onEventScheduled: (e) => updateCalendlyStatus(),
  });

  const updateCalendlyStatus = () => {
    const reqData = {
      status: "CALL_SCHEDULED",
    };
    updatePartner(reqData, props.partnerData.id)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Partner Approved successfully",
        });
        // setReload(!reload);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  // const [openMarket, setOpenMarket] = React.useState(false);
  // const handleCloseMarket = () => setOpen (false);
  const closeRequestCallModal = () => {
    setOpenCalendlyModal(false);
  };

  const handleClickOpenMarket = () => {
    setInforReq(true);
  };
  const handleCloseMarket = () => {
    setOpen(false);
  };

  const [openrqst, setOpenrqst] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpenrqst((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpenrqst(false);
  };

  const openRequestCall = () => {
    props.onRequestForCall(props.partnerData.id);
    // setOpenCalendlyModal(false);
  };

  const handleCloseInfoReq = () => {
    setInforReq("");
    setInforReqList([]);
  };

  // const handleSaveInfoReq = () => {
  //   inforReqList.forEach(async (item) => {
  //     try {
  //       const req = { ...item, partner_id: props.partnerData.id };
  //       await requestForInformation(req);
  //       setNotification({ type: "success", msg: "Email sent successfully" });
  //       setInforReq("");
  //     } catch (error) {
  //       setNotification({ type: "error", msg: error as string });
  //       console.error("Error occurred while processing request:", error);
  //     }
  //   });
  // };

  const handleSaveInfoReq = () => {
    if (
      props.partnerData?.user_partners &&
      props.partnerData?.user_partners.length > 0
    ) {
      inforReqList.forEach((item: any) => {
        props.partnerData?.user_partners?.forEach((c: any) => {
          const req = {
            ...item,
            partner_id: props.partnerData.id,
            consultant_id: c?.user_id,
          };
          requestForInformation(req).then((res) => {
            updateRequestForCall(props.partnerData.id);
          });
        });
      });
    } else {
      setNotification({
        type: "error",
        msg: "No consultant assigned",
      });
    }
  };

  const updateRequestForCall = (inforReq: any) => {
    console.log(inforReq, "inforReq");
    const reqData = {
      status: "INFORMATION_REQUESTED",
    };

    updatePartner(reqData, inforReq)
      .then((res) => {
        setInforReq("");
        setInforReqList([]);
        if (props.reload) {
          props.reload();
        }
        setNotification({
          type: "success",
          msg: "Information requested successfully",
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const onSubmitInfoReq = (data: any) => {
    setInforReqList([...inforReqList, data]);
    // reset();
  };

  const handleRemoveReqInfoItem = (index: any) => {
    const data = [...inforReqList];
    data.splice(index, 1);
    setInforReqList([...data]);
  };

  React.useEffect(() => {
    setCalendlyPrefill({
      email: props?.partnerData.name,
      name: props?.partnerData.poc_email,
    });
  }, [props]);

  const infoReqs = inforReqList.map((item, key) => {
    return (
      <Row className="mb16px mx-1" key={key}>
        <Col sm={3} lg={3} xl={3}>
          <Typography
            sx={{ textAlign: "left", color: "#1D2939", fontSize: "14px" }}
          >
            {item?.docName}
          </Typography>
        </Col>
        <Col sm={8} lg={8} xl={8}>
          <Typography
            sx={{ textAlign: "left", color: "#475467", fontSize: "12px" }}
          >
            {item?.description}
          </Typography>
        </Col>
        <Col sm={1} lg={1} xl={1}>
          <Button
            style={{
              minWidth: "40px",
              maxWidth: "40px",
              padding: "0",
              maxHeight: "40px",
              textAlign: "center",
              lineHeight: "20px",
            }}
            onClick={() => handleRemoveReqInfoItem(key)}
            className="badgepill-blue50  blue-text br-0 bold no-border align-center"
          >
            <img
              width="20px"
              className="listicon"
              src="../svgs/delete.svg"
              alt="Singapore"
            />
          </Button>
        </Col>
      </Row>
    );
  });

  return (
    <React.Fragment>
      {props.partnerData.user_partners &&
      props.partnerData.user_partners.length != 0 ? (
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="Button group with a nested menu"
        >
          <Button
            sx={{
              boxShadow: "none",
              transition: "none",
              backgroundColor: "#0152FB",
              textTransform: "capitalize",
            }}
            className="btn-primary12 adduser br-0 "
            size="small"
            aria-controls={openrqst ? "split-button-menu" : undefined}
            aria-expanded={openrqst ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            Request
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
      ) : (
        <></>
      )}
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={openrqst}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  <MenuItem onClick={openRequestCall}>
                    Request For Call
                  </MenuItem>
                  <MenuItem onClick={handleClickOpenMarket}>
                    Request for more information
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <Dialog
        className="modal_700"
        open={Boolean(inforReq)}
        onClose={handleCloseInfoReq}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Request For More Information"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseInfoReq}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Card
            sx={{
              boxShadow: "none",
              border: "1px solid #EEEAF5",
            }}
          >
            <Row
              sx={{
                color: "#344054",
                backgroundColor: "#fcfcfd",
                align: "center",
                lineHeight: "44px",
                textIndent: "12px",
              }}
              className=" font-14 py20 px-2"
            >
              <Col sm={3} lg={3} xl={3}>
                File
              </Col>
              <Col sm={8} lg={8} xl={8}>
                Description
              </Col>
              <Col sm={1} lg={1} xl={1} className="ml-n20">
                Actions
              </Col>
            </Row>
            <Form
              onSubmit={handleSubmit((data) => {
                onSubmitInfoReq(data);
              })}
            >
              <Row className="mb16px mx-1 ">
                <Col sm={3} lg={3} xl={3} className="p-03">
                  <Form.Group className="formgroup" controlId="docName">
                    <Form.Control
                      type="text"
                      placeholder="File Name"
                      {...register("docName", {
                        required: "* This field is required",
                      })}
                    />
                    <Form.Text muted>
                      <span>
                        {/* {errors?.first_name && (
                        <p className="error-form">
                          {String(errors.first_name?.message)}
                        </p>
                      )} */}
                      </span>
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col sm={8} lg={8} xl={8} className="p-03">
                  <Form.Group controlId="">
                    <Form.Control
                      style={{
                        textAlign: "left",
                        color: "#475467",
                        fontSize: "12px",
                      }}
                      as="textarea"
                      rows={3}
                      placeholder="sample text"
                      {...register("description", {
                        required: "* This field is required",
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col sm={1} lg={1} xl={1} className="p-03">
                  <Button
                    style={{
                      minWidth: "40px",
                      maxWidth: "40px",
                      padding: "0",
                      maxHeight: "40px",
                      textAlign: "center",
                      lineHeight: "20px",
                    }}
                    type="submit"
                    className="badgepill-blue50  blue-text br-0 bold no-border align-center"
                  >
                    <AddIcon
                      sx={{
                        fontSize: "19px",
                        fontWeight: "500",
                        alignItems: "center",
                      }}
                    />
                  </Button>
                </Col>
              </Row>
            </Form>
            {infoReqs}
          </Card>
        </DialogContent>
        <DialogActions>
          <FooterButton
            variant="outlined"
            onClick={handleCloseInfoReq}
          >
            Cancel
          </FooterButton>
          <FooterButton
            onClick={handleSaveInfoReq}
            autoFocus
          >
            Save
          </FooterButton>
        </DialogActions>
      </Dialog>
      <PopupModal
        url="https://calendly.com/aegsg"
        prefill={calendlyPrefill}
        onModalClose={() => setOpenCalendlyModal(false)}
        open={openCalendlyModal}
        rootElement={document.getElementById("root") as HTMLElement}
      />
      <Dialog
        className="modal_400"
        open={openRequestCallModal}
        onClose={closeRequestCallModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Call Request"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to request for a call ?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ minWidth: "100%" }}>
          <Button
            sx={{ width: "50%", color: "#344054", borderColor: "#D0D5DD" }}
            variant="outlined"
            onClick={closeRequestCallModal}
          >
            Cancel
          </Button>

          <Button
            sx={{
              width: "50%",
              color: "#FFFFFF",
            }}
            variant="contained"
            className="btn-primary12 adduser"
            onClick={() => {
              window.open("https://calendly.com/app/login", "_blank");
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
    </React.Fragment>
  );
}
